exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#user-page-tab .card {\n  border-top-right-radius: 0;\n  border-top-left-radius: 0;\n}\n#user-page-tab .vue-tabs .nav-tabs {\n  border-bottom: 0 solid #ddd;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21acc009","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard/Pages/Settings/Users/Index.vue
// module id = /++r
// module chunks = 4